/**
 * KPI-only means every TAG pen is hidden, leaving the derived KPI line and its
 * expectation. The pens stay SELECTED on purpose: the chart computes the derived
 * value from its dependencies, so deselecting them would delete the very line
 * the view is about. Hiding is therefore a visibility concern, not a selection
 * one — deselecting "the drivers" only ever removed the drivers the KPI
 * expression did not reference, which on a typical model is a single pen.
 *
 * Restoring deletes the keys rather than setting them true, so a pen the user
 * had hidden themselves stays hidden.
 */
export const kpiOnlyVisibility = (
  penIds: string[],
  hide: boolean,
  previous: Record<string, boolean>
): Record<string, boolean> => {
  const next = { ...previous }
  for (const id of penIds) {
    if (hide) next[id] = false
    else delete next[id]
  }
  return next
}
